"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointDeclaration = endpointDeclaration;
exports.bindDeclaration = bindDeclaration;
exports.bindScopedDeclaration = bindScopedDeclaration;
function endpointDeclaration(reqParser, respParser) {
    return {
        reqParser,
        respParser,
    };
}
function bindDeclaration(decl, handler) {
    if (typeof handler === 'function') {
        handler = new DelegatingHandler(handler);
    }
    return { decl, endpoint: handler, scopeProvider: () => undefined };
}
function bindScopedDeclaration(decl, handler, scopeProvider) {
    if (typeof handler === 'function') {
        handler = new DelegatingHandler(handler);
    }
    return { decl, endpoint: handler, scopeProvider };
}
class DelegatingHandler {
    handlerFunction;
    constructor(handlerFunction) {
        this.handlerFunction = handlerFunction;
    }
    handle(req, scope, httpRequestInfo) {
        return Promise.resolve(this.handlerFunction(req, scope, httpRequestInfo));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kcG9pbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VuZHBvaW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQWlDQSxrREFRQztBQWdCRCwwQ0FRQztBQUVELHNEQVNDO0FBM0NELFNBQWdCLG1CQUFtQixDQUNqQyxTQUF3QixFQUN4QixVQUEwQjtJQUUxQixPQUFPO1FBQ0wsU0FBUztRQUNULFVBQVU7S0FDWCxDQUFBO0FBQ0gsQ0FBQztBQWdCRCxTQUFnQixlQUFlLENBQzdCLElBQW9DLEVBQ3BDLE9BQThDO0lBRTlDLElBQUksT0FBTyxPQUFPLEtBQUssVUFBVSxFQUFFLENBQUM7UUFDbEMsT0FBTyxHQUFHLElBQUksaUJBQWlCLENBQXFCLE9BQU8sQ0FBQyxDQUFBO0lBQzlELENBQUM7SUFDRCxPQUFPLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxPQUFPLEVBQUUsYUFBYSxFQUFFLEdBQUcsRUFBRSxDQUFDLFNBQVMsRUFBRSxDQUFBO0FBQ3BFLENBQUM7QUFFRCxTQUFnQixxQkFBcUIsQ0FDbkMsSUFBb0MsRUFDcEMsT0FBNEMsRUFDNUMsYUFBd0M7SUFFeEMsSUFBSSxPQUFPLE9BQU8sS0FBSyxVQUFVLEVBQUUsQ0FBQztRQUNsQyxPQUFPLEdBQUcsSUFBSSxpQkFBaUIsQ0FBbUIsT0FBTyxDQUFDLENBQUE7SUFDNUQsQ0FBQztJQUNELE9BQU8sRUFBRSxJQUFJLEVBQUUsUUFBUSxFQUFFLE9BQU8sRUFBRSxhQUFhLEVBQUUsQ0FBQTtBQUNuRCxDQUFDO0FBRUQsTUFBTSxpQkFBaUI7SUFDUTtJQUE3QixZQUE2QixlQUFrRDtRQUFsRCxvQkFBZSxHQUFmLGVBQWUsQ0FBbUM7SUFBRyxDQUFDO0lBRW5GLE1BQU0sQ0FBQyxHQUFRLEVBQUUsS0FBWSxFQUFFLGVBQTRCO1FBQ3pELE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsZUFBZSxDQUFDLEdBQUcsRUFBRSxLQUFLLEVBQUUsZUFBZSxDQUFDLENBQUMsQ0FBQTtJQUMzRSxDQUFDO0NBQ0YifQ==